import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";
export const requestAuthOption = (method, data) => {
    let token = JSON.parse(localStorage.getItem("token"));

    let headers = {
        Authorization: `Bearer ${token}`,
    };

    // If data is NOT FormData, set Content-Type to application/json
    if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const requestOptions = {
        method: method,
        headers: headers,
        body: data instanceof FormData ? data : JSON.stringify(data)
    };

    return requestOptions;
};

export const productListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    let categories_id = '';
    if (payload?.categories_id?.length > 0) {
        // category_ids = payload.category_ids.map(id => `filter[category_ids][]=${encodeURIComponent(id)}`).join('&')
        categories_id = '&' + payload.categories_id.map(id => `filter[category_id][]=${encodeURIComponent(id)}`).join('&');
    } try {
        const response = await fetch(
            `${server}product?search=${payload?.keyword || ''}&sort_order=${payload?.sort}&paginate=${payload?.page}&size=${payload?.length || ''}&sort=${payload?.sort_by || ''}&filter[status]=${payload?.status === "all" ? "" : payload?.status}&filter[categories_id]=${categories_id}&filter[product_type]=${payload?.product_type === "0" ? "" : payload?.product_type}&filter[sales_platform]=${payload?.sales_platform === "0" ? "" : payload?.sales_platform}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const productDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}product/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                        resolve(data);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const approveRejectProductApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}product/update-creation-status`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const addProductApi = async (payload) => {
    const request = requestAuthOption("POST", payload?.product)
    try {
        const response = await fetch(
            `${server}product`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updateProductApi = async (payload) => {
    const request = requestAuthOption("PUT", payload?.product)
    try {
        const response = await fetch(
            `${server}product/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const deleteProductApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}product/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const deleteBulkProductApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}product/bulk-delete`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data.errors);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportProductApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}product/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportAccessoriesMasterApi = async () => {
    const request = requestAuthOption("POST", {});
    try {
        const response = await fetch(`${server}product/export-accessories-master`, request);
        const raw = await response.text();
        let data;
        try {
            data = JSON.parse(raw);
        } catch (e) {
            throw "Export API returned HTML instead of JSON. Confirm API files are uploaded (especially AccessoriesMasterCopyExporter.php and routes/api.php), then clear Laravel route cache.";
        }
        if (response.ok && data.code === "success") {
            return data;
        }
        if (data?.code === "login_needed") {
            Helpers.routeToLogin();
        }
        throw data?.message || data || "Failed to export accessories master copy";
    } catch (error) {
        throw error?.message || error || "Network response error, please try again later";
    }
};

export const exportAccessoriesBundleMasterApi = async () => {
    const request = requestAuthOption("POST", {});
    try {
        const response = await fetch(`${server}product/export-accessories-bundle-master`, request);
        const raw = await response.text();
        let data;
        try {
            data = JSON.parse(raw);
        } catch (e) {
            throw "Export API returned HTML instead of JSON. Confirm API files are uploaded (especially AccessoriesMasterCopyExporter.php and routes/api.php), then clear Laravel route cache.";
        }
        if (response.ok && data.code === "success") {
            return data;
        }
        if (data?.code === "login_needed") {
            Helpers.routeToLogin();
        }
        throw data?.message || data || "Failed to export accessories bundle master copy";
    } catch (error) {
        throw error?.message || error || "Network response error, please try again later";
    }
};

export const importProductApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}product-import`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        reject(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const importProductImagesApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    // Log FormData contents
    if (payload?.upload instanceof FormData) {
        for (let pair of payload.entries()) {
        }
    } else {
    }

    try {
        const response = await fetch(
            `${server}product-img-upload`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        reject(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const bulkAttachPdfApi = async (payload) => {
    const request = requestAuthOption("POST", payload);
    try {
        const response = await fetch(
            `${server}product/bulk-attach-pdf`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data.errors);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
            });
        });
    }
};

export const bulkUpdateProductStatusApi = async (payload) => {
    const request = requestAuthOption("POST", payload);
    try {
        const response = await fetch(
            `${server}product/bulk-update-status`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data.errors);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
            });
        });
    }
};

export const productListingForGiftApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}product?paginate=0&filter[product_type]=simple`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const productListingForAccessoriesApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}product?paginate=0&filter[product_type]=simple&filter[creation_status]=approved&filter[category_id]=${payload?.category_id || ""}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};